import PropTypes from 'prop-types';

import Typography from '@bequestinc/wui/basics/typography';

const Success = props => {
  const { header, message, subMessage } = props;

  return (
    <>
      <Typography variant="h4" component="h1">
        {header}
      </Typography>
      <Typography variant="body1">{message}</Typography>
      {subMessage && <Typography variant="body1">{subMessage}</Typography>}
    </>
  );
};

Success.propTypes = {
  header: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  subMessage: PropTypes.string,
};

Success.defaultProps = {
  subMessage: null,
};

export default Success;
